import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

import { HeaderContainer } from '@app/modules/core/header/components/header-container/header.container';
import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { HeaderState, headerFeatureName } from '@app/modules/core/header/store/state/header.state';
import { headerRootReducer } from '@app/modules/core/header/store/effects';
import { HeaderFacade } from '@app/modules/core/header/header.facade';
import { HeaderDirective } from '@app/modules/core/header/directives/header.directive';
import { BtnLoaderModule } from '@ux/components/btn-loader/btn-loader.module';
import { HeaderService } from '@app/modules/core/header/services/header.service';
import { UserNextTripsModule } from '@app/modules/shared/user-next-trips/user-next-trips.module';
import { UserHistoryFacade } from '@app/modules/user-history/user-history.facade';
import { HomeFacade } from '@app/modules/home/home.facade';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { UserAlertsModule } from '@user-alerts/user-alerts.module';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { CloseWebviewComponent } from '@app/modules/core/header/components/close-webview/close-webview.component';
import { ChipModule } from '@ux/components/chip/chip.module';
import { ButtonDsComponent } from '@design-system/components/molecules/button/button.component';
import { ChipActionDsComponent } from '@design-system/components/molecules/chip-action/chip-action.component';
import { HeaderDsComponent } from '@design-system/components/templates/header/header.component';
import { HeaderResultsContainer } from '@header/components/header-results/header-results.container';
import { HeaderReservationContainer } from '@header/components/header-reservation/header-reservation.container';
import { HotelDetailFacade } from '@hotels/hotel-detail/hotel-detail.facade';
import { HeaderAnimatedContainer } from '@header/components/header-animated/header-animated.container';

export const HEADER_REDUCER_TOKEN = new InjectionToken<
  ActionReducerMap<HeaderState>
  >('Feature Header Reducers');

@NgModule({
  declarations: [
    HeaderContainer,
    HeaderResultsContainer,
    HeaderReservationContainer,
    HeaderAnimatedContainer,
    HeaderDirective,
    CloseWebviewComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    GlobalPipesModule,
    TranslocoModule,
    StoreModule.forFeature(headerFeatureName, HEADER_REDUCER_TOKEN),
    BtnLoaderModule,
    UserNextTripsModule,
    SwipeUpModule,
    UserAlertsModule,
    LoadingBarModule,
    ChipModule,
    ButtonDsComponent,
    ChipActionDsComponent,
    HeaderDsComponent,
  ],
  exports: [
    HeaderContainer,
    HeaderResultsContainer,
  ],
  providers: [
    HeaderFacade,
    HeaderService,
    HomeFacade,
    UserHistoryFacade,
    HotelDetailFacade,
    {
      provide: HEADER_REDUCER_TOKEN,
      useValue: headerRootReducer
    }
  ]
})
export class HeaderModule { }
